/***
 *Â @FileName:
 *Â @Author: manyao.zhu
 *Â @Date: 2020-06-11 18:30:56
 */
import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

import { SettingsService } from '@ithinkdt/shared/browser';
import { COMMON_COMFIG, preventBubble } from '@ithinkdt/shared/utils';
import { LogoutService } from '@ithinkdt/theme/fetch-service';
import { ThemeConfig } from '@ithinkdt/theme/models';

@Component({
  selector: 'dt-feishu-settings',
  templateUrl: './feishu-settings.component.html',
  styleUrls: ['./feishu-settings.component.scss'],
})
export class FeishuSettingsComponent implements OnInit {
  @Input() showDialog: boolean;
  themeConfig: ThemeConfig;

  showStatus = true; // æ§å¶ç¶æç¼è¯
  @Output() closeDialog = new EventEmitter<any>();

  constructor(
    public settingSrv: SettingsService,
    private router: Router,
    public settings: SettingsService,
    private el: ElementRef,
    private logoutService: LogoutService
  ) {
    this.themeConfig = this.settingSrv.userConfig['theme'] || {};
  }

  ngOnInit() {}

  //
  descChange() {
    this.showStatus = !this.showStatus;
    const dom = this.el.nativeElement;
    setTimeout(() => {
      dom.querySelector('.dt-desc-input').focus();
    }, 300);
  }

  // è®¾ç½®æè¿° ï¼è¿éæ¯å¦è¯¥è°ç¨åç«¯æ¥å£ï¼
  descBlur() {
    setTimeout(() => {
      this.handleDesc(true);
    }, 300);
  }

  // å é¤æè¿°
  removeDesc() {
    this.handleDesc(false);
  }

  // å¤çä¹¦ååå é¤æè¿°çå¼  bæ¯å¦åæ¢ç¶æ
  handleDesc(b: boolean) {
    if (b) {
      this.setDesc();
      return;
    }
    this.deleteDesc();
  }

  // è®¾ç½®æè¿°
  setDesc() {
    this.showStatus = !this.showStatus;
    const user = this.settingSrv.user;
    this.settingSrv.setUser(user);
  }

  // å é¤æè¿°
  deleteDesc() {
    let user = this.settingSrv.user;
    user = Object.assign(user, { description: null });
    this.settingSrv.setUser(user);
  }

  // æå¤§çåºå±æ¡çç¹å»å³é­å¼¹çªäºä»¶
  closeDialogs() {
    this.closeDialog.emit();
  }

  // é²æ­¢åæ³¡
  stopPropagation(evt) {
    preventBubble(evt);
  }

  logout() {
    this.logoutService.logout().subscribe((res) => {
      this.settingSrv.resetSettings();
      this.router.navigateByUrl(COMMON_COMFIG.LOGIN_URL);
    });
  }
}
